<template>
  <div class="wrap">
    <div class="banner">
	    <img src="../assets/img/banner2025.png" alt="">
    </div>
    <section class="section firsts">
        <p class="">
        一年一度的东南·中国建筑新人赛盛大归来！2026年，我们将再聚南京，在这里与来自不同学校的优秀选手肩并肩、与高水平的指导教师团队面对面；2026年，我们与去年保持一致，突破传统、追求独立，东南·中国建筑新人赛继续专注于中国建筑学的低年级教育、展现中国建筑新生的优异风采，着力于为低年级学生提供更好的竞赛平台与更多的交流机会。
	</p><br/>
        <div class="title">新人赛是什么</div>
        <p>
            新人赛为建筑学学生作业展示与竞赛、各国建筑教育者提供了积极的交流平台。 

        </p>
        <p class="">
            东南大学建筑学院突出“自主、开放、交流”的特点，面向全国各高校的本科一年级至三年级建筑专业学生征稿，旨在为年轻鲜活的低年级设计者提供竞赛平台，并鼓励他们展现创造性与合理性并存的设计思维，体现中国建筑学科的新生力量。 

        </p>
	    <div class="img-box"><img src="../assets/img/home-group-photo-2025.jpg" alt=""></div>
        <div class="title">新人赛新在哪儿</div>
        <p>
            中国建筑新人赛的定位是搭建全新的、颠覆传统建筑竞赛形式的竞赛平台，本质上是一场开放自由的建筑秀场和交流会。 
	    </p>
        <p>
            新人赛通过微信平台、作品网络提交、志愿者线下联系等多种途径让赛事信息最快传达；赛事经过海选评出的100强选手将被邀请至东南大学建筑学院，与来自五湖四海的建筑学学子彼此学习，与诸多建筑界精英面对面讨论方案、交流思想。同时，新人赛通过开放评选、学生参与、自发交流的三方面特点来消除传统竞赛作品提交、评选、发布等环节脱离，选手间、选手与主办方脱节的弊端。 
	    </p>
        <p>
	    </p>
        <p class="">
            让我们期待一同享受这属于建筑学界的饕餮盛宴！
	    </p>
    </section>
    <section class="section">
        <div class="title">组织机构</div>
        <div class="title_wrap"><span class="title_name linetitle">主办方</span></div>
        <div class="lastp">东南大学建筑学院、东南大学建筑设计研究院有限公司</div>
        <div class="title_wrap"><span class="title_name linetitle">协办方</span></div>
        <div class="lastp">《建筑学报》</div>
    </section>
    <section class="section">
        <div class="title">参赛资格</div>
        <div class="subtitle">参赛者</div>
        <div>
            我们欢迎中国（含港澳台）各高校<i style="font-weight: bold;">建筑学院（建筑系）三年级及以下</i>在读本科生投稿<br/><br/>
        </div>
        <div></div>
        <div class="subtitle">提交作品</div>
        <div>
            前述参赛者在<i style="font-weight: bold;">本科阶段一年级至-三年级</i>学习期间的建筑设计作业<br/><br/>
        </div>
        <div></div>
        <div class="subtitle">竞赛主题</div>
        <div></div>
        <div>
            不设置竞赛主题，以各校教学环节的 <i style="font-weight: bold;">设计任务书</i>为依据
        </div>
        <div></div><br/><br/>
        <div  class="subtitle">注意事项：</div>
        <div></div>
        <div>
1. 以上条件必须同时满足<br/>
2. 每个参赛者只能提交一份参赛作品<br/>
3. 规划类或风景园林类专业学生亦可参赛，但投稿作品必须是建筑设计作品<br/>
4. 提交作品应基于设计课作业成果，可进行一定的修改和完善，需提交设计科任务书且必须为本教学年度（2025-2026学年）作品（例：三年级同学只能提交第三学年作品，不得提交第一或第二学年作品）<br/>
5. 不接受已经在其他竞赛中获奖的作品<br/>
6. 不接受任何形式的合作作品（合作作品仅一人署名也不接受）<br/>
7. 作品需以实体模型为重要表现载体，不接受无实体模型作品，入围100强的作品需按要求修改并提交至少一张模型照片<br/>
        </div>
    </section>
    <section class="section">
        <div class="title">赛程</div>
        <!--
        <div class="title_wrap"><span class="title_name linetitle">中国建筑新人赛</span></div>
        -->
        <div class="subtitle">即日起-2026.8.5</div>
        <div class="lastp">报名并提交电子图纸到本网站。请按照网页提示内容填写参赛者个人信息，并依步骤上传图纸
        </div>
        <div class="smalltitle ">图纸内容</div>
        <div class="lastp">封面1张，任务书1页，图纸4页，视频1个（如需要）
        </div>
        <div class="smalltitle">注意事项</div>
        <div class="lastp">封面尺寸统一为800*600，图纸、任务书大小不超过2MB，分辨率在4000*4000以内，支持jpeg格式和png格式，除了登录信息以外，图纸上不得出现任何与参赛学校或个人相关的信息，否则投稿作品作废。图纸中不得使用繁体字。
      </div>
        <div class="subtitle">2026.8.5-2026.8.11</div>
<!--
        <div class="smalltitle ">作品初筛</div>
        <div class="lastp">评审团队对已提交作品根据规范性进行初筛，在本次初筛中不通过的作品将不参加后续的海选正式评选。
        </div>
-->
        <div class="smalltitle">海选评选</div>
        <div class="lastp">由各高校负责本科建筑设计教学的教师组成评委团队进行线上匿名打分，5分制，每个作品得分为三名评委的分数的平均分。并以此得分决定进入100强的参赛作品。
        </div>
        <div class="smalltitle">网站公示</div>
        <div class="lastp">海选评选获奖结果经确认后将在本网站公布，同时公开100强作品供阅览。
        </div>
        
        <div class="subtitle">2026.8.23-2026.9.17</div>
        <div class="lastp">进入前100名的参赛者对图纸进行修改与第二轮提交。（提交通道将于8.23开启）
        </div>
        <div class="smalltitle">第二轮提交内容</div>
        <div class="lastp">每位参赛者提交2-5张图纸（A2横版）及1-2张实体模型照片（A2横版）
（具体要求将后续通知）</div>
        <div class="subtitle">2026.9.19上午</div>
        <div class="smalltitle">100进16强决赛</div>
        <div class="lastp">评选方式：评委线下投票
届时100强选手将来到现场参与布展，9月19日上午评委将在现场为图纸打分
        </div>
       <!-- 
        <div class="smalltitle">图纸要求</div>
        <div class="lastp">封面要求正方形，文件格式jpg小于1M，规定为2000*2000像素；图纸要求2-5张图纸，及1-2 张实体模型照片，文件格式 jpg，每张小于 2M。
        </div>
       --> 

        <div class="subtitle">2026.9.19下午</div>
        <div class="smalltitle">总决赛</div>
        <div class="lastp">评选方式：线下答辩
9月19日下午16强选手现场答辩，现场产生前三获得者
        </div>
    </section>
    <section class="section">
        <div class="title">奖项设置</div>
        <div class="smalltitle">中国建筑新人赛Top3</div>
	<div>获得证书、纪念品及10000元奖金</div>
        <div class="smalltitle">中国建筑新人赛Top16</div>
	<div>获得证书、纪念品及2000元奖金</div>
        <div class="smalltitle">中国建筑新人赛Top100</div>
	<div>获得证书、纪念品</div><br/>
        <div class="img-box"><img src="../assets/img/home-2025-logo-banner.png" alt=""></div>
        <el-dialog
          title="提示"
          :visible="centerDialogVisible"
          width="90%"
          center>
          <span>本网站不支持移动端浏览，为了更好的用户体验，请在电脑上登录网站进行大赛报名</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">关 闭</el-button>
          </span>
        </el-dialog>
    </section>
  </div>
</template>




<script>
import axios from 'axios'

export default {
  inject: ['reload'],
  data () {
    return {
      centerDialogVisible: false,
    }
  },
  created () {
    if (this.isMobile()) {
        this.centerDialogVisible = true
    }
  },
  computed: {
    
  },
  mounted(){
  },
  methods: {
    isMobile: function() {
        var userAgentInfo = navigator.userAgent;
        var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
        var mobile_flag = false;
        //根据userAgent判断是否是手机
        for (var v = 0; v < mobileAgents.length; v++) {
            if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
                mobile_flag = true;
                break;
            }
        }
         var screen_width = window.screen.width;
         var screen_height = window.screen.height;
         //根据屏幕分辨率判断是否是手机
         if(screen_width < 500 && screen_height < 800){
             mobile_flag = true;
         }
         return mobile_flag;
    }
  }
}
</script>
<style scoped lang='stylus' rel="stylesheet/stylus">
@import '~@/common/stylus/index'

.clearfix:after{
  content:"";
  clear:both;
}
.clearfix{
  *zoom: 1;
}
.wrap{
    text-align: left;
}
.title{
    font-family: sybold;
    font-size: 30px;
    color:#25335e;
    text-align: center;
}
p{
    font-family: sylight;
    color:black;
    font-size: 16px;
    text-align: justify;
    line-height: 1.8em;
    margin-top:10px;
    text-indent: 2em;
}
.banner{
    height: 600px;
    width: 100%;
    position: relative;
}
.banner img{
    height: 100%;
    width: 100%;
    position: relative;
}
.section{
    padding: 30px calc((100% - 1024px) / 2) 0;
}
.img-box {
    padding: 20px;
}
.img-box img {
    width: 100%;
    display: block;
}
.title {
    font-size: 26px;
    color: #25335e;
}
.linetitle {
    font-size: 20px;
}
.subtitle {
    font-size: 18px;
    width: 800px;
    color: #182345;
    text-align: left;
}
.smalltitle {
    font-size: 16px;
    width: 300px;
    color: #25335e;
    text-align: left;
}
.lastp{
    margin-bottom: 10px;
    white-space: pre-line;
}
.prep{
    white-space: pre-line;
}
.notification {
    color: red;
    }

.title_wrap {
    margin-bottom: 20px;
}
.firsts {
    margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// Home.vue?313b73bd